import { lazy } from '@/service/lazy'

export default [{
  name: 'Status de Assinaturas',
  path: 'statusassinatura',
  id: 'statusassinatura',
  icon: 'fa fa-id-card',
  component: lazy('app/default/adm_financeiro/statusassinatura/index'),
  meta: { requireAuth: true, rules: ['status_assinaturas'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/statusassinatura.js